import React, { useEffect, useState } from 'react';
import { Card } from '@/components/ui/Card';
import { api } from '@/api/client';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/Table';
import { formatDateTime } from '@/utils/helpers';

export const Activity = () => {
  const [activity, setActivity] = useState([]);

  useEffect(() => {
    loadActivity();
  }, []);

  const loadActivity = async () => {
    try {
      const res = await api.getActivity();
      setActivity(res.data);
    } catch (error) {
      console.error('Error loading activity:', error);
    }
  };

  return (
    <div className="space-y-6" data-testid="activity-page">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Activity Log</h1>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>User</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Table</TableHead>
              <TableHead>Details</TableHead>
              <TableHead>Time</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {activity.map((item) => (
              <TableRow key={item.id}>
                <TableCell className="font-medium">{item.user_name}</TableCell>
                <TableCell>{item.action}</TableCell>
                <TableCell>{item.table}</TableCell>
                <TableCell className="max-w-xs truncate">{item.details || '-'}</TableCell>
                <TableCell>{formatDateTime(item.timestamp)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
};
